import React from 'react';

export default class NotificaAssenzaWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sending: false, 
            sent: false, 
        };
    }

    render() {

        return(
            <div style={main}>
                {this.props.assenza.selected ? <img src={require('../images/selected.png')} onClick={() => this.props.onSelect()} style={{ width: 20, height: 20, top: 15, position: 'absolute', cursor: 'pointer' }} /> : <div style={{ width: 20, minHeight: 20, borderRadius: 10, backgroundColor: 'darkgrey', cursor: 'pointer', top: 15, position: 'absolute' }} onClick={() => this.props.onSelect()}>&nbsp;</div> }
                <p style={{...child, left: 60}}>{this.props.assenza.studente}</p>
                <p style={{...child, left: 430}}>{this.props.assenza.percentualeAssenze} %</p>
                <p style={{...child, left: 530}}>{this.props.assenza.presenzeTotali}/{this.props.assenza.totaleLezioni}</p>
            </div>
        );
    }
}

const main = {
    backgroundColor: '#E6E6E6', 
    paddingTop: 5, 
    paddingBottom: 5,
    marginBottom: 5, 
    paddingLeft: 20, 
    paddingRight: 20, 
    width: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    borderRadius: 10,
    position: 'relative', 
    height: 50,
}

const child = {
    top: -5, 
    fontWeight: 'bold', 
    fontSize: 18, 
    position: 'absolute',
}